// extracted by mini-css-extract-plugin
module.exports =  {"list-item":"DTwxxPA","listItem":"DTwxxPA","category":"rleRWUb","image-wrapper":"QIkI1k0","imageWrapper":"QIkI1k0","title":"ZyZBAe1"};